import type {
  LocationSelectParentOptionItemData,
  LocationSelectParentOptionItemValue,
  LocationSelectParentProps,
} from "./location-select-parent.type";

import { useTranslation } from "react-i18next";

import { filterAncestorsSelfAndChildren } from "@/entities/ancestor";
import { LOCATIONS_FILTERS } from "@/entities/locations";
import QueryableSelect from "@/modules/queryable-select";

import LocationSelectOption from "./location-select-parent-option";

const LocationSelectParent = ({
  selectedOrganization,
  currentLocationId,
  parentOrganizationRequired = true,
  ...props
}: LocationSelectParentProps) => {
  const { t } = useTranslation();
  const label = t("global:locationOrSector");

  return (
    <QueryableSelect<
      LocationSelectParentOptionItemValue,
      LocationSelectParentOptionItemData
    >
      data-testid="location-select-parent"
      name="location"
      model="locations"
      filterBy="name"
      label={label}
      placeholder={label}
      optionFormat={LocationSelectOption}
      filterCallback={
        currentLocationId
          ? (option) =>
              filterAncestorsSelfAndChildren({
                ancestors: option.ancestors,
                itemType: "location",
                itemId: currentLocationId,
              })
          : undefined
      }
      additionalFilters={
        selectedOrganization
          ? { [LOCATIONS_FILTERS.ORGANIZATION_ID]: selectedOrganization }
          : undefined
      }
      disabled={parentOrganizationRequired && !selectedOrganization}
      {...props}
    />
  );
};

export default LocationSelectParent;
